module.exports = __webpack_public_path__ + "media/images/banner-e5a2da1567057c679cc60153cbeb2836.jpg";